import type { RouteRecordRaw } from "vue-router";

export const homeRoutes: RouteRecordRaw[] = [
  {
    path: "/home",
    name: "home",
    alias: "/",
    component: () => import(/* webpackChunkName: "dashboard-home" */ "../../components/home/HomeView.vue"),
    meta: { titleKey: "pageTitle.home", viewGroup: "home" }
  }
];
